jQuery(document).ready(function () {
	
	/**
	 *
	 * @param {array} aParams
	 * @param {array} aExcluded
	 * @param {function} callback
	 */
	function getFilterResults(aParams, aExcluded, callback){
		$.get(
			`/util/ajaxresponse.php?lng=${pageLng}&${createParamsString(aParams, [])}`,
			function(data) {
				
				if(data == ''){
					return;
				}

				if(callback){
					var jqueryHtml = $(data);
					callback(jqueryHtml);
				}

				setSimplePagination();

				var params = `${createParamsString(aParams, aExcluded)}`;
				
				if (history){
					history.pushState(null, null, '?' + params);
				}
			}
		).fail(
			function(data){
				$('.data-content').html("Error occurred!");
			}
		)

		function createParamsString(aParams, aExcluded){
			return Object.keys(aParams)
					.filter((key) => aExcluded.indexOf(key) === -1)
					.reduce((joined, current) => {
						if(aParams[current] === null || aParams[current] === ''){
							return joined;
						}
						return joined + `&${current}=${aParams[current]}`
					}, '').substring(1);
		}
	}
	
	function onPaginationNewsClick(pageNumber, e){
		e.preventDefault();
		
		//var idRubric = $('.news-tabs li.active').attr('data-id');
		var strid = $('#body-content').attr('data-strid');
		var page = pageNumber;
		
		getFilterResults({func: 'get-page-news', /*idrubric: idRubric,*/ page: page, str: strid}, ['func', 'str'], function(jqueryHtml){
			$('.data-content').empty();
			$('.data-content').append(jqueryHtml);
			window.scrollTo(0, 0);
		});
	}
	
	function onPaginationEventsClick(pageNumber, e){
		e.preventDefault();
		
		//var idRubric = $('.news-tabs li.active').attr('data-id');
		var strid = $('#body-content').attr('data-strid');
		var page = pageNumber;
		
		getFilterResults({func: 'get-page-events', /*idrubric: idRubric,*/ page: page, str: strid}, ['func', 'str'], function(jqueryHtml){
			$('.data-content').empty();
			$('.data-content').append(jqueryHtml);
			window.scrollTo(0, 0);
		});
	}
	
	function callNewPageData(pageNumber, event, functionName){
		if(functionName == 'get-news'){
			onPaginationNewsClick(pageNumber, event);
		}else if(functionName == 'get-events'){
			onPaginationEventsClick(pageNumber, event);
		}
	}
	
	function setSimplePagination(){
		if($('.pagination').length){
			//var currentTheme = $('html').attr('data-theme');
			$('.pagination').pagination({
				displayedPages: 3,
				edges: 1,
				ellipsePageSet: false,
				items: $('.pagination').attr('data-total'),
				itemsOnPage: $('.pagination').attr('data-limit'),
				currentPage : $('.pagination').attr('data-current'),
				nextText: '<img src="/images/backgrounds/icons/arrow-right.svg" alt="Naslednja stran" title="Naslednja stran">',
				prevText: '<img src="/images/backgrounds/icons/arrow-left.svg" alt="Prejšnja stran" title="Prejšnja stran">',
				onPageClick: function(pageNumber, event) {
					var functionName = $('.pagination').attr('data-func');
					callNewPageData(pageNumber, event, functionName);
				}
			});
		}
	}
	setSimplePagination();
	
});